const getYoutubeID = url => {
	if (url.includes('vimeo.com')) {
		const vimeo = /vimeo.*\/(\d+)/i.exec(url);
		return `https://player.vimeo.com/video/${vimeo[1]}`;
	}

	const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
	const match = url.match(regExp);

	if (match && match[2].length === 11) {
		return `https://www.youtube.com/embed/${match[2]}?rel=0&showinfo=0&modestbranding=0&enablejsapi=1`;
	}
	// fallback to just trying to embed the main url
	return url;
};

export default getYoutubeID;
